module.exports = __webpack_public_path__ + "img/BlinkArt_Sword2_Red.58535c3b.png";